import PropTypes from "prop-types";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";
import "./PopoverInfo.scss";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";

const PopoverInfo = ({
	popOverContent,
	popOverClassName = "",
	popOverContainerClassName = "",
	popOverButtonClassName = "",
	popOverContentClassname = "",
}) => {
	return (
		<FloatingButton
			popoverClassName={`popover-info ${popOverClassName ?? ""}`}
			floatingContainerClassName={`popover-info__container ${popOverContainerClassName ??
				""}`}
			referenceButtonClassName={`popover-info__button  ${popOverButtonClassName ?? ""}`}
			position="bottom"
			floatingContent={
				// eslint-disable-next-line local-rules/no-dynamic-classname
				<div className={`popover-info__content ${popOverContentClassname}`}>
					{popOverContent}
				</div>
			}
			referenceComponent={<IconInfo width={15} height={15} style={{ marginLeft: "5px" }} />}
			zIndexValue={10}
		/>
	);
};

PopoverInfo.propTypes = {
	popOverContent: PropTypes.object,
	popOverClassName: PropTypes.string,
	popOverContainerClassName: PropTypes.string,
	popOverButtonClassName: PropTypes.string,
	popOverContentClassname: PropTypes.string,
};

export default PopoverInfo;
